/* eslint-disable import/order */
import { DialogActions, DialogContent, Grid, Stack } from "@mui/material";
import { MutationStatus } from "@tanstack/react-query";
import { Form as FormikForm, FormikProvider, useFormik } from "formik";
import { ArrowRight, Mail } from "lucide-react";
import React from "react";
import * as yup from "yup";

// COMPONENTS:

import FormikTextField from "components/forms/FormikTextField";
import FormSection from "components/forms/FormSection";
import UltimateButton from "components/UltimateButton";

export type CustomerFormStep1Values = {
  email: string;
};

interface ICustomerFormStep1 {
  handleSubmit: (values: CustomerFormStep1Values) => void;
  handleClose: () => void;
  submitStatus?: MutationStatus;
  customerFormStepper: JSX.Element;
  hubspotUserSearching: boolean;
}

const CustomerFormStep1: React.FC<ICustomerFormStep1> = ({
  handleClose,
  handleSubmit,
  submitStatus,
  customerFormStepper,
  hubspotUserSearching,
}) => {
  const schema = yup.object({
    email: yup.string().email("Wrong email format").required(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { email: "" },
    validationSchema: schema,
    onSubmit: handleSubmit,
  });

  return (
    <FormikProvider value={formik}>
      <FormikForm>
        <DialogContent>
          {customerFormStepper}
          <Stack spacing={3} sx={{ mt: 2 }}>
            <FormSection
              title="Customer Email"
              description="Enter email to lookup customer from HubSpot."
              Icon={Mail}
            >
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikTextField name="email" label="Email" />
                </Grid>
              </Grid>
            </FormSection>
          </Stack>
        </DialogContent>
        <DialogActions>
          <UltimateButton
            type="submit"
            Icon={
              ArrowRight as React.ComponentType<{
                size?: number;
                className?: string;
                style?: React.CSSProperties;
              }>
            }
            loading={hubspotUserSearching}
            text="Next"
            sx={{
              minWidth: 150,
              py: 1.5,
            }}
          />
        </DialogActions>
      </FormikForm>
    </FormikProvider>
  );
};

export default CustomerFormStep1;
